<section id="favorites" aria-live="polite" (click)="updateFavoriteShoes()">
    <h2 tabindex="0">Favorites</h2>
    <div *ngIf="userService.currentUser != null; then authenticated else guest">
    </div>
    <ng-template #authenticated>
      <div *ngIf="userService.user$ | async as user">
        <h3>{{ user.displayName }}'s Favorite Shoes</h3>
        <button (click)="userService.signOut()">Logout</button>
      </div>
      <div class='row'id='favorites-row'>
        <ng-container *ngFor="let searchShoe of favorites">
          <div class="col-lg-4">
            <app-favorite-shoe-card [shoe]="searchShoe"></app-favorite-shoe-card>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #guest>
      <h3>Sign in to save and track your favorite shoes!</h3>
      <button (click)="userService.googleSignin()">
        <i class="fa fa-google"></i> Log in with Google
      </button>
    </ng-template>
</section>